import { render, staticRenderFns } from "./UploadInvoice.vue?vue&type=template&id=ccf815c2&scoped=true&"
import script from "./UploadInvoice.vue?vue&type=script&lang=js&"
export * from "./UploadInvoice.vue?vue&type=script&lang=js&"
import style0 from "./UploadInvoice.vue?vue&type=style&index=0&id=ccf815c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf815c2",
  null
  
)

export default component.exports